import CtaComponent from './cta.component'

export default CtaComponent
